module.exports = __webpack_public_path__ + "img/bin.a8196f02.svg";